<template>
  <div class="civii-messages-container">
    <div class="civii-message left">
      <div class="civii-message-content select-tramite">
        <label>{{ titulo }}</label>
        <div class="input-group">
            <input autofocus type="date" @change="activarBotonSiFechaSeleccionadaEstaDisponible" v-model="fechaCita" :disabled="disabilitarItem" class="form-control" :max="valorMax" :min="valorMin" />
            <div class="input-group-append">
                <button class="button button-primary" v-if="mostrarItem" @click="seleccionarFecha">Prosseguir</button>
            </div>
        </div>
        <span style="color: red;font-size: .70rem;" v-show="mostrarMensajeErrorFecha"> {{mensajeErrorFecha}} </span>
      </div>
    </div>        
  </div>
</template>

<style scoped>
 .select-tramite .input-group .form-control{
  position: relative;
    -ms-flex: 1 1 auto;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0;
    margin-bottom: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.input-group .button{
    display: inline-block;
    font-weight: 400;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: var(--secondary);
    border: 1px solid var(--secondary);
    padding: .375rem .75rem;
    font-size: 1rem;
    cursor: pointer;
    line-height: 1.5;
    border-radius: .25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.button.button-primary{
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
}
.button-primary:hover {
    background-color: var(--secondary-dark);
    border-color: var(--secondary-dark);
}

.input-group{
  position: relative;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-align: stretch;
  align-items: stretch;
  width: 100%;
  margin-top: .5rem;
}
.input-group-append {
    margin-left: -1px;
}
.form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    outline: 0;
}
</style>



<script>
import { mapActions } from 'vuex';
export default {
    props: {
        titulo: {
            type: String,
        },
        identificador: {
            type: String
        },
        valorMax:{
            type: String
        },
        valorMin:{
            type:String
        },
        fechasValidas: {
            type: Array,
            default: []
        },
        fechaBloqueo: {
            type: Number
        },
        formato:{
            type:String
        }
    },
    methods: {
        ...mapActions(["sendMessage"]),
        activarBotonSiFechaSeleccionadaEstaDisponible(){
            this.mostrarItem = this.fechasValidas.length == 0 || this.fechasValidas.some( fecha => fecha === this.fechaCita );
            this.mostrarMensajeErrorFecha = !this.mostrarItem;
        },
        seleccionarFecha() {
            var fechaTexto;

            if (this.fechaCita != null) {
                sessionStorage.setItem(this.identificador, this.fechaCita);

                switch (this.formato) {
                    case "formatoDDMMYYYY":
                        fechaTexto = this.formatoDDMMYYYY(this.fechaCita);
                        break;
                    default:
                        fechaTexto = this.formatoYYYYMMDD(this.fechaCita);
                        break;
                }

                this.disabilitarItem = true;
                this.mostrarItem = false;
                this.sendMessage({
                    message: fechaTexto,
                    token: "token",
                });
            }
        },
        formatoDDMMYYYY: function( formatoInput ) {
        let fechaSeparada = formatoInput.split("-")
        return `${fechaSeparada[2]}/${fechaSeparada[1]}/${fechaSeparada[0]}`
        },
        formatoYYYYMMDD: function( formatoShopping ){
            let fechaSeparada = formatoShopping.split("/")
            return `${fechaSeparada[2]}-${fechaSeparada[1]}-${fechaSeparada[0]}`
        },
    },
    data: function () {
        return {
            fechaCita: new Date(),
            mostrarItem: false,
            disabilitarItem: false,
            mostrarMensajeErrorFecha: false,
            mensajeErrorFecha: $MESSAGES.MensajesCitasPlugin.messages.consultarCitas.noHayCitas,
        };
    },
    created: function() {
        if(this.fechaBloqueo < new Date().getTime() ) {
            this.disabilitarItem = true;
            this.mostrarItem = false;
        }
    }
};
</script>


// WEBPACK FOOTER //
// src/components/answers/Date/Date.vue